import React from 'react';

import CategoryCourses from './category-courses';
import NewCourses from './new-courses';
import TopCourses from './top-courses';
import TopTeachers from './top-teachers';

const CoursesLanding = () => (
  <div className='p-2 sm:p-4'>
    <TopCourses />
    <TopTeachers />
    <NewCourses />
    <CategoryCourses />
  </div>
);

export default CoursesLanding;
